<template>
	<div v-if="!serverBusy">
		<div class="center-content">
			<input
				type="checkbox"
				id="terms-and-conditions"
				name="terms-and-conditions"
				title="Terms And Conditions"
				v-model="termsAndConditions"
			/>
			<label for="termsAndConditions" title="Terms And Conditions" class="terms-and-conditions-font">{{ languageStrings.checkingBoxAgreeTerms }}<a @click="getTermsAndConditions()" class="center-content" style="color: white; margin-bottom: 1%; font-size: xx-small;">{{ languageStrings.termsAndConditions }}</a></label>
		</div>
		<div v-if="showTermsAndConditions">
				<!-- <TermsAndConditions
					:playerState="playerState"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:tosContent="tosContent"
					:latestVersion="latestVersion"
					:showAcceptAndContinue="false"
				/> -->
				<DocumentDisplay
					:playerState="playerState"
					:isMobile="isMobile"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:newDocuments="newDocuments"
					:documentList="documentList"
					:showAcceptAndContinue="false"
				/>
		</div> 	
		<div class="button-container" :class ="restrictedNeedsMoreInfo&&
							fromPlayerCashCOC  >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit  ? 'disable-container' : ''">
			<button class="btn buy-in-btn curved-border" :disabled="restrictedNeedsMoreInfo &&
							fromPlayerCashCOC   >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit"  :id="`commit-offer${buyInOffer.id}`" @click="order()">
				{{ languageStrings.commitTransaction }}
			</button>
		</div>
	</div>
</template>

<script>
import sharedScripts from "@/dependencies/sharedScripts";
import { onBeforeUnmount } from "vue";
import router from "@/router";
import DocumentDisplay from "./DocumentDisplay.vue";

export default {
	name: "NuveiCashIn",
	props: {
		playerState: Object,
		webPayOptions: Object,
		systemCurrencyTool: Object,
		buyInOffer: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		fromPlayerCashCOC: Number,
		providerName: String, 
		restrictedNeedsMoreInfo: Boolean,
		paymentMethodCode: String,
		playerLimit: Number,
		hasBeenBlockedForBuyInAndCashOut: Boolean
	},
	components: {
		DocumentDisplay
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			statuses: [
				"failedAuthentication",
				"buyInAmountEmpty",
				"valueIsNotANumber",
				"meetMinimumBuyInAmount",
				"exceededMaximumBuyInAmount",
				"completeNeoCheck",
				"IdCheckRequired",
				"EmailNotVerified",
				"fetchStatusGood",
				"webPayIniateFailed",
				"Success"
			],
			serverBusy: false,
			tosContent:"",
			latestVersion: {},
			termsAndConditions: false,
			showTermsAndConditions: false,
			newDocuments:[],
		};
	},
	watch: {
	},
	created() {
		this.eventBus.on("closeTos", () => {
			this.showTermsAndConditions = false;
		});
	},
	mounted() {},
	methods: {
		async order() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.initiatingBuyIn;

			let hasErrors = false;
			this.eventBus.emit("checkForSpamRequest");

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				//failedAuthentication
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[0]);
			}

			//buyInAmountEmpty
			if (!this.fromPlayerCashCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[1]);
			}


			//valueIsNotANumber
			if (isNaN(this.fromPlayerCashCOC)){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[2]);
			}


			//meetMinimumBuyInAmount
			if (this.fromPlayerCashCOC < this.buyInOffer.minimumCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[3]);
			}


			//exceededMaximumBuyInAmount
			if (this.fromPlayerCashCOC > this.buyInOffer.maximumCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[4]);
			}

			let maxCOC =
				this.webPayOptions?.taxAmlRestrictions?.idCheckNeeded ||
				this.webPayOptions?.taxAmlRestrictions?.morePersonalInfoNeeded
					? this.webPayOptions?.taxAmlRestrictions?.cashOutThresholdCOC
					: this.webPayOptions?.nuvei?.cashOutMaximumCOC;

			//completeNeoCheck
			if (this.fromPlayerCashCOC > maxCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[5], maxCOC);
			}

			if (hasErrors === true){
				this.serverBusy = false;
				return;
			}

			let body = {
				CasinoId: this.webPayOptions.casino.id,
				BuyInOfferId: this.buyInOffer.id,
				FromPlayerCashCOC: this.fromPlayerCashCOC,
				provider: this.providerName,
				
			};
			// paymentMethodCode: this.paymentMethodCode


			let requestUrl = new URL("/api/v1/webpay/buyin/initiate", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					this.serverBusy = false;
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				this.transaction = await response.json();
				if (this.transaction?.status === this.statuses[6]) {
					console.error(this.transaction?.status);
					this.serverBusy = false;
					//IdCheckRequired
					this.handleStatusMessage(this.statuses[6]);
					return;
				}

				if (this.transaction?.status === this.statuses[7]) {
					console.error(this.transaction?.status);
					this.serverBusy = false;
					//EmailNotVerified
					this.handleStatusMessage(this.statuses[7]);
					return;
				}

				//fetchStatusGood
				if (fetchStatus.ok) this.handleStatusMessage(this.statuses[8], null, this.transaction);

				//Success
				if (this.status.message === this.statuses[10]) this.handleStatusMessage(this.statuses[10]);
				this.serverBusy = false;
				this.performNuveiCheckout();
			} catch (e) {
				//webPayIniateFailed
				this.handleStatusMessage(this.statuses[9]);
				this.serverBusy = false;
				console.error(e);
			}
		},

		handleStatusMessage(causeOfMessage, maxCOC = null, transaction = null){
			// this.serverBusy = false;
			// this.busyText = "";

			//failedAuthentication
			if(causeOfMessage === this.statuses[0]) return false;
	
			this.status.ok = false;
			if(causeOfMessage === this.statuses[8]){
				//fetchStatusGood
				this.status = sharedScripts.checkSuccessErrors(transaction.status, this.languageErrorStrings);
				this.eventBus.emit("updateStatus", this.status);
			}
			else{
				this.status.message = sharedScripts.statusMessage(causeOfMessage, this.languageErrorStrings, this.systemCurrencyTool,maxCOC);
				this.eventBus.emit("updateStatus", this.status);
			}
			

			return false;

		},
		// Dummy function, but you get the idea.  Obviously we need something more robust than this.
		getTwoLetterCountry(phoneCountryCode) {
			switch (phoneCountryCode) {
				case 1:
					return "US";
				case 52:
					return "MX";
				default:
					return "US";
			}
		},
		performNuveiCheckout() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.displayNuveiPurchaseWidget;

			/*
		Log levels for Nuvei's Simply Connect "checkout" API.
		Possible values:
			0 (default) – No logging
			1 – Plain text
			2 – Info
			3 – Warn
			4 – Error
			5 – Debug
			6 – Trace
		*/
			const nuveiLogLevel = 0;

			// About countries and payment methods:
			// The top-level country field is where we, the merchant, do business.  For Encore this will be MX, for instance.
			// The billingAddress.country is the player/user/consumer's country, and we base that on their phone number.
			// According to Andres Mauricio Clavijo Mantilla in our Teams chat on 2024-01-19, only credit cards are allowed for
			// foreigners to the business country, not "alternate payment methods" such as PayPal or OXXOPay.
			// The API fails quite severely if you try.  So we're using the "payment method whitelist" to make sure that
			// APMs aren't offered if the countries don't match.  (If no whitelist or blacklist are given, Nuvei shows all
			// methods we're set up to use.)
			const billingAddrCountry = this.getTwoLetterCountry(this.webPayOptions.userPhoneCountryCode);
			const payMethodWhitelist =
				billingAddrCountry === this.webPayOptions.nuvei.merchantTwoLetterCountryCode ? null : ["cc_card"];

			// Hard-coding the locale for this prototype.  In production, we should use whatever mechanism we're using for
			// front-end language elsewhere.
			let rfServer;
			let statusArea;
			let rfWebTransaction;
			let sessionId;
			let alreadyShowingResults;

			// if (document.getElementById("webpay-checkout-element").innerHTML !== "") {
			// 	checkout.destroy();
			// }

			// Tell Nuvei to create their UI inside one of our DOM elements.
			document.getElementById("webpay-checkout-element").innerHTML = "";
			const checkoutParams = {
				sessionToken: this.transaction.sessionId,
				env: this.webPayOptions.nuvei.environment,
				merchantSiteId: this.webPayOptions.nuvei.merchantSiteId,
				merchantId: this.webPayOptions.nuvei.merchantId,
				country: this.webPayOptions.nuvei.merchantTwoLetterCountryCode,
				currency: this.webPayOptions.cashOutCurrency.iso4217Code,
				locale: this.systemCurrencyTool.cultureCode,
				userId: this.transaction.transaction.userId,
				amount: this.transaction.transaction.fromPlayerCashCOC,
				pmWhitelist: payMethodWhitelist,
				renderTo: "#webpay-checkout-element",
				logLevel: nuveiLogLevel,
				billingAddress: {
					country: billingAddrCountry,
					email: this.webPayOptions.userEmailAddress,
					phone: this.webPayOptions.userPhoneNumber,
				},
				showResponseMessage: false,
				onResult: this.handleNuveiCheckoutResult,
				onPaymentEvent: this.handleNuveiPaymentEvent,
			};


			checkout(checkoutParams);
			this.eventBus.emit("showNuveiWidgit");
			this.serverBusy= false;
		},
		async handleNuveiCheckoutResult(result) {
			let response = await result;

			if (response?.status === "ERROR" && !response?.statusAdditionalInfo) {
				// this.fromPlayerCashCOC = null;
				checkout.destroy();
				this.eventBus.emit("handelNuveiError", response);
				return;
			}

			if (response?.result) {
				this.nuveiResult = response;
				// this.fromPlayerCashCOC = null;
				checkout.destroy();
				setTimeout(() => {
					this.showRfTranStatus();
				}, 1500);
			}
		},
		async handleNuveiPaymentEvent(result) {
			let response = await result;

			if (response?.result) {
				// this.fromPlayerCashCOC = null;
				checkout.destroy();
				this.eventBus.emit("nuveiCheckoutResult", this.nuveiResult);
			}
		},
		async showRfTranStatus() {
			this.busyText = this.languageStrings.loadingBuyIns;
			this.serverBusy = true;

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let requestUrl = new URL(
				`api/v1/webpay/transaction/${this.transaction.transaction.id}`,
				this.rabbitsfootHostUrl
			);
			let params = requestUrl.searchParams;

			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverBusy = false;
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();
				this.transactionResult = dataJson;

				if (this.transactionResult?.status === "RefusedByProvider") {
					// this.fromPlayerCashCOC = null;
					checkout.destroy();
					this.eventBus.emit("handelNuveiError", this.transactionResult);
					return;
				}

				this.eventBus.emit("nuveiCheckoutResult", this.transactionResult);

				this.busyText = "";
				this.serverBusy = false;
			} catch (e) {
				this.status.ok = false;
				this.status.message = e;
				console.error(e);
			}

			headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			requestUrl = new URL("api/v1/funds/", this.rabbitsfootHostUrl);
			params = requestUrl.searchParams;

			if (this.transaction.transaction.casinoId) params.set("casinoId", this.transaction.transaction.casinoId);

			requestUrl.search = params.toString();

			request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);
				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverBusy = false;
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();

				this.playerFunds = dataJson;
			} catch (e) {
				this.status.ok = false;
				this.status.message = e;
				console.error(e);
			}
		},
		getTermsAndConditions() {
			this.getLatestTosDocument();
		
		},
		async getLatestTosDocument() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.loadingTermsAndConditions;
			// this.tosList = "testing test";
			// this.tosContent = "done testing";
			// console.log("this si the tos list", this.tosList);
			//here for testing purposes
			
			try {
				this.tosList = await this.listDocuments(this,"tos", 10);
				if (!this.tosList?.length > 0) {
					this.serverBusy = false;
					this.busyText = "";
					this.status.message = "There are no tos files avaliable";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				}
				this.latestVersion = this.compareDocumentVersions(this.tosList);

				let documentUrl =
					this.latestVersion.url.indexOf("http") === 0
						? this.latestVersion.url
						: `./${this.latestVersion.url}`;

				let content = await fetch(documentUrl);
				let dataJson = await content.text();
				this.tosContent = this.removeScriptTag(dataJson);
				this.showTermsAndConditions = true;
				this.newDocuments.push(this.latestVersion);

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = e;
				this.eventBus.emit("updateStatus", this.status);
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buy-in-btn {
	width: 100%;
	height: 100%;
	margin: 0;
}

button.btn:disabled {
	background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important;
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

.disable-container {
	opacity: .9 !important;
}

.terms-and-conditions-font {
	font-size: xx-small;
}

.center-content {
	display: inline-flex;
	justify-content: center;
}

a:hover {
	cursor: pointer;
}

a {
	text-decoration: underline;
}

</style>
